module.exports = __webpack_public_path__ + "img/hero-velans-le_canyon.3369fac.jpg";